var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckOn = function SvgCheckOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3h18v18H3V3Zm2.954 9.024L10.5 16.57l3.773-3.772 3.773-3.773-1.592-1.591-5.954 5.955-2.954-2.955-1.592 1.591Z",
    fill: "#1C69D4"
  })));
};
export { SvgCheckOn as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyAgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMgM0gyMVYyMUgzVjNaTTUuOTU0MSAxMi4wMjQxTDEwLjQ5OTkgMTYuNTY5MUwxNC4yNzI3IDEyLjc5NjZMMTguMDQ1NiA5LjAyNDEyTDE2LjQ1NDEgNy40MzI2MkwxMC40OTk5IDEzLjM4NzZMNy41NDU2IDEwLjQzMjZMNS45NTQxIDEyLjAyNDFaIiBmaWxsPSIjMUM2OUQ0Ii8+Cjwvc3ZnPgo=";